import { FC, useCallback, useContext } from "react";
import { Currency, TranslationScopes } from "@finbackoffice/enums";
import { CurrencyShortNames } from "@finbackoffice/fe-core";
import { ConfigContext, useRuntimeConfig } from "@finbackoffice/site-core";
import Translate from "components/base/translate/Translate";
import styles from "../policies.module.sass";
import PoliciesCommonContent from "../PoliciesCommonContent";

const CurrenciesList = [
    Currency.XRP,
    Currency.TRX,
    Currency.USDT_TRC20,
    Currency.DOGE,
    Currency.LTC,
    Currency.BTC,
];

const PoliciesPayments: FC = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { sitePaymentsConfig } = useContext(ConfigContext);

    const renderSection = useCallback(
        (id: string) => (
            <section key={id} className="ms_faq ms_card">
                <div>
                    <div>
                        <Translate
                            tid={`policies_payments_${id}_question`}
                            dangerous
                            namespace={TranslationScopes.PoliciesPayments}>
                            {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
                            <h2 />
                        </Translate>
                    </div>
                    <div>
                        <Translate
                            tid={`policies_payments_${id}_answer`}
                            dangerous
                            namespace={TranslationScopes.PoliciesPayments}>
                            <div />
                        </Translate>
                    </div>
                </div>
            </section>
        ),
        [],
    );

    return (
        <PoliciesCommonContent
            translationKey="payments"
            translationScope={TranslationScopes.PoliciesPayments}
            headingIcon={{ width: 20, height: 20 }}
            wrapperClassName={styles.payments}>
            <p>
                <Translate
                    tid="policies_payments_headTxt"
                    namespace={TranslationScopes.PoliciesPayments}
                    replace={{
                        app_name: COMMON_SITE_CONFIGS.appName,
                    }}
                />
            </p>
            <div>
                <h1 className={styles.faqHeadText}>
                    <Translate
                        tid="policies_payments_head"
                        namespace={TranslationScopes.PoliciesPayments}
                    />
                </h1>

                {["1", "2", "3"].map((id) => renderSection(id))}
            </div>
            {sitePaymentsConfig && (
                <ul>
                    {CurrenciesList.map((item: Currency) => {
                        const wallet = sitePaymentsConfig[item];
                        return (
                            wallet && (
                                <li key={item}>
                                    {`${wallet?.deposit?.min} - `}
                                    {CurrencyShortNames[item] || item}
                                    {` - `}
                                    <Translate tid={`currencies_${item.toLowerCase()}`} />
                                </li>
                            )
                        );
                    })}
                </ul>
            )}
            <div>{["4", "5"].map((id) => renderSection(id))}</div>

            {sitePaymentsConfig && (
                <ul>
                    {CurrenciesList.map((item: Currency) => {
                        const wallet = sitePaymentsConfig[item];
                        return (
                            wallet && (
                                <li key={item}>
                                    {`${wallet?.withdrawal?.min} - `}
                                    {CurrencyShortNames[item] || item}
                                    {` - `}
                                    <Translate tid={`currencies_${item.toLowerCase()}`} />
                                </li>
                            )
                        );
                    })}
                </ul>
            )}
            <div>
                {["6", "7", "8", "9", "10", "11", "12", "13", "14"].map((id) => renderSection(id))}
            </div>
        </PoliciesCommonContent>
    );
};

export default PoliciesPayments;
